import { multipartyReferences } from './multiparty-references.js'
import { references } from './references.js'
import { community } from './community.js'

const data: any = { references, community, multipartyReferences }

export default data
